module.exports = __webpack_public_path__ + "static/media/arrow-point-to-right.061af1af.png";